(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.map = {
    attach: function (context, drupalSettings) {
      const mapSwitcher = $('.map-switcher')
      if (mapSwitcher.length) {
        const akteurList = $('.tab-view.list');
        const akteurMap = $('.tab-view.map');
        if (mapSwitcher.attr('class').indexOf('list') !== -1) {
          akteurList.addClass('active')
        }
        else {
          akteurMap.addClass('active')
        }
        mapSwitcher.on('change', function () {
          if (mapSwitcher.attr('class').indexOf('list') !== -1) {
            akteurList.addClass('active')
            akteurMap.removeClass('active')
            createCookie('activeAkteureFilterTab', 'list');
          }
          else {
            akteurList.removeClass('active')
            akteurMap.addClass('active')
            createCookie('activeAkteureFilterTab', 'map');
            setMapFitBounce();
          }
        })
        setMapFitBounce();
      }
    }
  };
  function setMapFitBounce() {
    setTimeout(()=> {
      if (Drupal.geolocation && Drupal.geolocation.maps) {
        const maps = Object.values(Drupal.geolocation.maps);
        const lastMapIndex = maps.length - 1;
        const map = maps[lastMapIndex];
        const markers = map.mapMarkers;
        if (markers) {
          var bounds = new google.maps.LatLngBounds();
          markers.forEach(function (marker) {
            bounds.extend(marker.getPosition());
          });
          map.fitBoundaries(bounds);
        }
      }
    }, 300)
  }
})(jQuery, Drupal);